import { FavoritePortal } from "./favorite-portals.model";

export class FavoritePreferences {
    FavoritePortals: FavoritePortal[];
   }